// FieldText Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import validator from 'validator'
import classNames from 'classnames'

import Input from '../../common/input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Util from '../../../lib/util.jsx'

class FieldText extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bEdit: props.autoFocus,
      isFocus: false
    }

    this._references = {
      field: React.createRef()
    }
  }

  static get propTypes () {
    return {
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      autoFocus: PropTypes.bool,
      showEdit: PropTypes.bool,
      validations: PropTypes.array,
      onSave: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      value: '',
      autoFocus: false,
      showEdit: false,
      validations: [],
      onSave: null,
      onBlur: null,
      onFocus: null
    }
  }

  componentDidMount () {
    if (this.props.autoFocus) {
      this.focus()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this.props.showEdit &&
      this.state.bEdit &&
      this.state.bEdit !== prevState.bEdit
    ) {
      this.focus()
    }
  }

  focus () {
    if (this._references.field.current) {
      this._references.field.current.focus()
    }
  }

  render () {
    const {
      showEdit,
      validations,
      onSave,
      onFocus,
      onBlur,
      className,
      ...others
    } = this.props // eslint-disable-line
    const { bEdit, isFocus } = this.state

    const _className = classNames(className, {
      hasfocus: isFocus
    })

    return (
      <div
        className={`field field-text${
          showEdit && !bEdit ? ' disableedit' : ''
        }`}
      >
        <div className='fieldcontent'>
          <Input
            ref={this._references.field}
            styleType='fieldinput'
            isNumber={this._isTypeNumber()}
            onKeyDown={this._onKeyDown.bind(this)}
            onBlur={this._onBlur.bind(this)}
            onFocus={this._onFocus} // eslint-disable-line react/jsx-handler-names
            className={_className}
            {...others}
          />
        </div>
        {showEdit &&
          (bEdit ? (
            <IconButton
              className='fieldaction'
              icon='done'
              type='primary'
              onClick={this._onSave.bind(this)}
            />
          ) : (
            <IconButton
              className='fieldaction'
              icon='edit'
              type='secondary'
              canHover
              onClick={this._onEnabledEdit.bind(this)}
            />
          ))}
      </div>
    )
  }

  /* Event Handlers */
  _onEnabledEdit () {
    this.setState({ bEdit: true })
  }

  _onSave (ev) {
    const { value, onSave } = this.props

    if (this._validate(value)) {
      this.setState({ bEdit: false })

      if (onSave) {
        onSave(ev)
      }
    }
  }

  /* Private FUnctions */
  _onKeyDown (ev) {
    if (ev.keyCode === 13) {
      ev.preventDefault()

      this._onSave(ev)
    }
  }

  _onBlur (ev) {
    this._onSave(ev)
    this.setState({ isFocus: false })

    const { onBlur } = this.props
    if (onBlur) {
      onBlur()
    }
  }

  _onFocus = ev => {
    this.setState({ isFocus: true })

    const { onFocus } = this.props
    if (onFocus) {
      onFocus(ev)
    }
  }

  _validate (value) {
    const validations = this.props.validations
    if (validations !== undefined && validations.length > 0) {
      for (let i = 0; i < validations.length; i++) {
        if (!this._validateField(value, validations[i])) {
          return false
        }
      }
    }

    return true
  }

  _validateField (val, validType) {
    switch (validType) {
      case 'required':
        return val ? !validator.isEmpty(val.toString()) : false
      case 'email':
        return validator.isEmail(val)
      case 'positive':
        return this._isPostiveNumber(val)
      case 'url':
        return validator.isAlphanumeric(val)
      case 'username':
        return validator.isAlphanumeric(val)
      case 'password':
        return !(validator.isEmpty(val) || !Util.isValidPassword(val))
      case 'phone':
        return validator.isMobilePhone(val)
      case 'website':
        return validator.isURL(this.getValueAsWebsite(val))
      case 'intlphone':
        return Util.isValidPhoneNumber(val)
      default:
        return true
    }
  }

  getValueAsWebsite (val) {
    if (
      val &&
      val.toLowerCase().indexOf('http://') === -1 &&
      val.toLowerCase().indexOf('https://') === -1
    ) {
      return `https://${val}`
    }

    return val
  }

  _isPostiveNumber (value) {
    const floatVal = parseFloat(value)

    return !isNaN(floatVal) && floatVal > 0
  }

  _isTypeNumber () {
    return false
  }
}

export default FieldText
